import script from "./AppNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./AppNavigation.vue?vue&type=script&setup=true&lang=js"

import "./AppNavigation.vue?vue&type=style&index=0&id=ebef7ba2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebef7ba2"]])

export default __exports__